import { render, staticRenderFns } from "./TopicEdit.vue?vue&type=template&id=7f3db244&scoped=true&"
import script from "./TopicEdit.vue?vue&type=script&lang=js&"
export * from "./TopicEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3db244",
  null
  
)

export default component.exports